export const data={
    particulars_detail:'',
    description:'',
    remember: true,
}